export default "__VITE_ASSET__DuIjZULD__"